export function SetupContainer({ children }: React.PropsWithChildren) {
  return (
    <div className="mx-auto w-full max-w-md">
      <div className="px-4 pt-6 text-center">
        <img
          alt="Screenrights"
          className="mx-auto max-w-48"
          src="/screenrights-logo.svg"
        />
      </div>
      <div className="mt-4 rounded-lg border border-sr-highlight bg-white shadow-md">
        {children}
      </div>
    </div>
  );
}

export function ErrorBanner({ message }: { message: string }) {
  return (
    <div className="mb-3 rounded-md bg-sr-input-error p-3">
      <p className="text-sm text-sr-dark-red">{message}</p>
    </div>
  );
}
